import React from "react";
import * as styles from "./ECommerceBenefits.module.scss";
import { ECommerceBenefitsContentFragment } from "types/graphql-types";
import { ABTestDomAttr } from "src/ab-test-experiments/client/use-experiment-tag";

export type ECommerceBenefitsProps = ECommerceBenefitsContentFragment &
  Partial<ABTestDomAttr>;

const ECommerceBenefits: React.FC<ECommerceBenefitsProps> = ({
  title,
  benefits,
  ...abTestDomAttr
}) => {
  return (
    <div className={styles.container} {...abTestDomAttr}>
      <div className={styles.title}>{title?.localized}</div>
      <ul className={styles.list}>
        {benefits?.map((b) => <li key={b?._key}>{b?.localized}</li>)}
      </ul>
    </div>
  );
};

export default ECommerceBenefits;
